//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_passGlobe = 2.0;\n\
";
